import React, { createContext, useContext } from 'react';
import ConfirmDialog from '../../components/ConfirmDialog';
import { useConfirmDialogProvider } from './useConfirmDialogProvider';
import { ConfirmDialogContextType, ConfirmDialogProviderProps } from './types';
import './ConfirmDialogProvider.module.css';

// 確認ダイアログのコンテキスト
const ConfirmDialogContext = createContext<ConfirmDialogContextType | null>(null);

/**
 * 確認ダイアログの状態を管理するプロバイダーコンポーネント
 */
export const ConfirmDialogProvider: React.FC<ConfirmDialogProviderProps> = ({ children }) => {
  const { dialogState, confirm, handleConfirm, handleCancel } = useConfirmDialogProvider();

  return (
    <ConfirmDialogContext.Provider value={{ confirm }}>
      {children}
      <ConfirmDialog
        isOpen={dialogState.isOpen}
        title={dialogState.title}
        message={dialogState.message}
        confirmLabel={dialogState.confirmLabel}
        cancelLabel={dialogState.cancelLabel}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </ConfirmDialogContext.Provider>
  );
};

/**
 * 確認ダイアログを使用するためのカスタムフック
 */
export const useConfirmDialog = (): ConfirmDialogContextType => {
  const context = useContext(ConfirmDialogContext);
  if (!context) {
    throw new Error('useConfirmDialog must be used within a ConfirmDialogProvider');
  }
  return context;
};

export default ConfirmDialogProvider; 